"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniq = exports.isEmpty = exports.applyTo = exports.curry = exports.compose = exports.pipe = void 0;
/* istanbul ignore file */
var pipe_1 = require("./pipe");
Object.defineProperty(exports, "pipe", { enumerable: true, get: function () { return pipe_1.pipe; } });
var compose_1 = require("./compose");
Object.defineProperty(exports, "compose", { enumerable: true, get: function () { return compose_1.compose; } });
var curry_1 = require("./curry");
Object.defineProperty(exports, "curry", { enumerable: true, get: function () { return curry_1.curry; } });
var applyTo_1 = require("./applyTo");
Object.defineProperty(exports, "applyTo", { enumerable: true, get: function () { return applyTo_1.applyTo; } });
var isEmpty_1 = require("./isEmpty");
Object.defineProperty(exports, "isEmpty", { enumerable: true, get: function () { return isEmpty_1.isEmpty; } });
var uniq_1 = require("./uniq");
Object.defineProperty(exports, "uniq", { enumerable: true, get: function () { return uniq_1.uniq; } });
